import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from './user.reducer';

export const selectUserState = createFeatureSelector<fromUser.IUserState>(fromUser.userFeatureKey);
export const selectLogins = createSelector(selectUserState, (s) => s.logins);
export const selectCurrentUser = createSelector(selectUserState, (s) => s.current);
